import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"tag, sale"} maskId="square-filled-radius-0-stroke-1-IconTag"><path fillRule="evenodd" clipRule="evenodd" d="M2 12.2071V2H12.2071L22.2071 12L12 22.2071L2 12.2071ZM7 8.5C7.82843 8.5 8.5 7.82843 8.5 7C8.5 6.17157 7.82843 5.5 7 5.5C6.17157 5.5 5.5 6.17157 5.5 7C5.5 7.82843 6.17157 8.5 7 8.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTag;
